import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface IndexAppConvertRequest {
  target: {
    searchPath: string;
  };
  entitySchema: {
    schemaPath: string;
  };
  viewSchema?: unknown;
}

export interface IndexAppConvertResult<T = unknown> {
  resultCode: number;
  resultMessage: string | null;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class ConverterService {
  private readonly http = inject(HttpClient);

  convert<T = unknown>(req: IndexAppConvertRequest, options?: { simulation?: boolean }): Observable<IndexAppConvertResult<T>> {
    const params = new HttpParams()
      .set('bucketCode', environment.bucketCodeMapping)
      .set('simulation', String(options?.simulation ?? true));

    return this.http.post<IndexAppConvertResult<T>>(`${environment.convertApiUrl}/converter`, req, { params });
  }
}

